/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select Driver ${i?.number}`)
};

const es_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar Piloto ${i?.number}`)
};

const de_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fahrer ${i?.number} wählen`)
};

const nl_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecteer coureur ${i?.number}`)
};

const fr_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionner Pilote ${i?.number}`)
};

const it_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona Pilota ${i?.number}`)
};

const pt_br2_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecionar Piloto ${i?.number}`)
};

const pt_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecionar Piloto ${i?.number}`)
};

const ja_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ドライバー ${i?.number} を選択`)
};

const zh_f1_team_selector_select_driver = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择车手${i?.number}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ number: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_team_selector_select_driver = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_team_selector_select_driver(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_team_selector_select_driver", locale)
	if (locale === "en") return en_f1_team_selector_select_driver(inputs)
	if (locale === "es") return es_f1_team_selector_select_driver(inputs)
	if (locale === "de") return de_f1_team_selector_select_driver(inputs)
	if (locale === "nl") return nl_f1_team_selector_select_driver(inputs)
	if (locale === "fr") return fr_f1_team_selector_select_driver(inputs)
	if (locale === "it") return it_f1_team_selector_select_driver(inputs)
	if (locale === "pt-BR") return pt_br2_f1_team_selector_select_driver(inputs)
	if (locale === "pt") return pt_f1_team_selector_select_driver(inputs)
	if (locale === "ja") return ja_f1_team_selector_select_driver(inputs)
	return zh_f1_team_selector_select_driver(inputs)
};